import styled from "styled-components";

export const Container = styled.div`
    width:min(80rem , 95%);
    display: grid;
    grid-template-columns:repeat(auto-fit, minmax(20.4375rem, 1fr) );
    margin: 0 auto;
    gap: 1.5rem;
`